<template>
    <div class="footer">
        <dl>
            <dt><img src="@/assets/images/headerLogo.png" alt=""></dt>
            <dd>
                <p>权利卫士</p>
                <span>随时随地 取证固证</span>
            </dd>
        </dl>
        <div class="downBtn">
            <span @click="downLoad">立即下载</span>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        pageId: { type: Number, default: 1 },
    },
    data() {
        return {
            u:'',
            isAndroid:'',
            isIOS:'',
            isWx:'',
            isHarmony:''
        };
    },

    components: {},

    computed: {},

    created() {
        this.u = navigator.userAgent;
        this.isAndroid = this.u.indexOf('Android') > -1 || this.u.indexOf('Linux') > -1; //android终端
        this.isIOS = !!this.u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        this.isHarmony=/OpenHarmony/i.test(ua);
    },

    mounted() {},

    methods: {
        is_weixn(){  
            let ua = navigator.userAgent.toLowerCase();  
            if(ua.match(/MicroMessenger/i)=="micromessenger") {  
                return true;
            } else {  
                return false;
            }  
        },
        downLoad(){
            if(this.is_weixn()){
                if(this.isAndroid){
                    this.$toast({
                        message:'跳转中，请稍候，若长时间未跳转请点击右上角选择“在浏览器打开”',
                        duration: 0
                    })
                }else if(this.isHarmony){
                    window.location.href = "https://appgallery.huawei.com/app/detail?id=cn.tsa.rights";
                    return
                }else{
                    window.location.href = "authorguard://";
                    this.checkOpen();
                }
            }else{
                //如果安装app直接唤醒app，否则去下载页面下载
                if (this.isAndroid) {
                    // 安卓的scheme协议跳转
                    window.location.href = "mobile://tsa.cn";
                    this.checkOpen();
                } else if (this.isIOS) {
                    window.location.href = "authorguard://";
                    this.checkOpen();
                }else if(this.isHarmony){
                    window.location.href = "https://appgallery.huawei.com/app/detail?id=cn.tsa.rights";
                }else{
                    let link = document.createElement("a");
                    link.style.display = "none";
                    link.target = "_blank";
                    link.href = 'https://m.tsa.cn/quanliweishi.html';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        },
        /**
         * 获取页面隐藏属性的前缀
         * 如果页面支持 hidden 属性，返回 '' 就行
         * 如果不支持，各个浏览器对 hidden 属性，有自己的实现，不同浏览器不同前缀，遍历看支持哪个
         */
        getPagePropertyPrefix() {
            const prefixes = ["webkit", "moz", "ms", "o"];
            let correctPrefix;
            if ("hidden" in document) return "";
            prefixes.forEach(prefix => {
                if (`${prefix}Hidden` in document) {
                    correctPrefix = prefix;
                }
            });
            return correctPrefix || false;
        },
        /**
         * 判断页面是否隐藏（进入后台）
         */
        isPageHidden() {
            const prefix = this.getPagePropertyPrefix();
            if (prefix === false) return false;
            const hiddenProperty = prefix ? `${prefix}Hidden` : "hidden";
            return document[hiddenProperty];
        },
        /**
         * 获取判断页面 显示|隐藏 状态改变的属性
         */
        getVisibilityChangeProperty() {
            const prefix = this.getPagePropertyPrefix();
            if (prefix === false) return false;
            return `${prefix}visibilitychange`;
        },
        /**
         * 检测是否唤端成功
         */
        checkOpen() {
            const visibilityChangeProperty = this.getVisibilityChangeProperty();
            const timer = setTimeout(() => {
                const hidden = this.isPageHidden();
                if (!hidden) {
                    window.location.href='https://m.tsa.cn/quanliweishi.html'
                }
            }, 2000);
            if (visibilityChangeProperty) {
                document.addEventListener(visibilityChangeProperty, res => {
                    clearTimeout(timer);
                });
                return;
            }
            window.addEventListener("pagehide", () => {
                clearTimeout(timer);
            });
        }
    },
};
</script>
<style lang="less" scoped>
.footer{
    position: fixed;
    bottom:0;
    left: 0;
    display: flex;
    font-size: 16px;
    justify-content: space-between;
    width: 100%;
    height: 120px;
    padding:0 31px;
    background:#EBF3FF;
    align-items: center;
    dl{
        display: flex;
        align-items: center;
        padding-top: 15px;
        dt{
            img{
                width: 66px;
                height: 66px;
            }
            margin-right: 19px;
        }
        dd{
            padding-top: 10px;
            p{
                color:#3988FE;
                font-size: 30px;
                font-weight: bold;
                margin:0;
            }
            span{
                font-size: 24px;
                color:#999999;
            }
        }
    }
    .downBtn{
        span{
            display: block;
            width: 160px;
            height: 66px;
            text-align: center;
            line-height: 66px;
            background:#3988FE;
            color: #fff;
            border-radius: 5px;
        }
    }
}
</style>
